import type { AssetTypesListBreadcrumbProps } from "./asset-types-list-breadcrumb.type";
import type { BreadcrumbItem } from "@/modules/breadcrumb";

import { Spin } from "antd";

import Breadcrumb from "@/modules/breadcrumb";
import { useModelLink } from "@/modules/model-link";

import { NO_VALUE } from "./asset-types-list-breadcrumb.constant";

export const AssetTypesListBreadcrumb = ({
  assetTypes,
  isLoading,
}: AssetTypesListBreadcrumbProps) => {
  const { getModelLink } = useModelLink();

  const items: BreadcrumbItem[] = assetTypes.map((assetType) => ({
    title: `${assetType.id}`,
    href: getModelLink("assettype", assetType),
    model: "assettype",
  }));

  if (isLoading) {
    return <Spin />;
  }

  if (items.length === 0) {
    return NO_VALUE;
  }

  return <Breadcrumb items={items} />;
};
